import {
	WeaTools
} from 'ecCom'

export const getAuth = (params) => {
	return WeaTools.callApi('/api/hrm/deptsalaryrp/getHasRight', 'GET', params);
}

export const getRadioGroupDatas = (params) => {
	return WeaTools.callApi('/api/hrm/deptsalaryrp/getSearchCondition', 'GET', params);
}

export const getDeptSalaryList = (params) => {
	return WeaTools.callApi('/api/hrm/deptsalaryrp/getDeptSalaryList', 'GET', params);
}

export const getResourceSalaryList = (params) => {
	return WeaTools.callApi('/api/hrm/deptsalaryrp/getResourceSalaryList', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/staffPayroll.js